export const STUDENT_LIST: string = 'STUDENT-LIST'
export const PARENT_INVITATION: string = 'PARENT-INVITATION'
export const MOBILE_APP: string = 'MOBILE-APP'
